export default "https://c.travel-assets.com/partner-portal/tools-lg-connectivity-illustration.68360d060a30.svg";